import { DeviceRow } from 'components/tables/data/device/types';
import DeviceNameBreadcrumbs from 'components/DeviceNameBreadcrumbs';

/**
 * Column for device name.
 */
export default function DeviceNameColumn({ data: device }: { data: DeviceRow }) {
  return <DeviceNameBreadcrumbs {...device} withDeviceImage />;
}
